import { JSX } from 'react';

import { ContentWrapper } from '../content-wrapper';
import { Logos } from '../logos';
import { useStyles } from './footer.styles';

export const Footer = (): JSX.Element => {
  const classes = useStyles();

  return (
    <footer className={classes.root} data-testid="footer">
      <ContentWrapper externalStyles={classes.contentStyles}>
        <Logos />
      </ContentWrapper>
    </footer>
  );
};
